import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// third-party
import { Provider as ReduxProvider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MainProvider } from 'contexts/MainContext';

// scroll bar
import 'simplebar/src/simplebar.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';

// project import
import App from './App';
import { store } from 'store';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';
import 'i18nConfig';
import { Loader } from 'react-feather';
import { Suspense } from 'react';

import * as Sentry from '@sentry/react';

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  Sentry.init({
    dsn: 'https://734403de3cc944f085d29ae5a1725fd1@o4504626394562560.ingest.sentry.io/4505011256033280',
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    release: 'my-project-name@' + process.env.REACT_APP_VERSION
  });
}

const queryClient = new QueryClient();

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Suspense fallback={<Loader />}>
    <ReduxProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider>
          <MainProvider>
            <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
              <App />
            </BrowserRouter>
          </MainProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </ReduxProvider>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
